import React from "react";
import "./styles.css";
import "../../../styles/Style.css"
import Navbar from "../../../layout/Navbar/Navbar";
import Sidebar from "../../../layout/Sidebar/SideBar";
import Equipment from "../../organisms/Equipment";

export default function EquipamentTemplate() {
  return (
    <>
      {/* organism */}
      <Navbar />
      {/* organism */}
      <Sidebar />
      {/* organism */}
      <Equipment />
    </>
  );
}

